import _ from "lodash";
import { setContext } from "@apollo/client/link/context";

import { Sentry } from "services/sentry";

import { getUserInfo, isPublicPlatformRoute } from "Login/modules/LoginModule";
import { getExtensions } from "services/tracing";
import { i18n } from "lib/i18n";

import { store } from "store/createStore";
import { connectionManager } from "lib/ablyInstance";
// Checks if the user in localStorage and redux is same
const checkIsValidUser = ({ userInfo }) => {
  const { user_type, id } = userInfo;
  const state = store.getState();
  const isUserComingFromPublicAccess = _.get(
    state,
    "login.isUserComingFromPublicAccess",
    false
  );

  if (isUserComingFromPublicAccess) return true;
  const userIdentityDetails = _.get(state, "login.userIdentityDetails", []);

  const validIds = _.map(userIdentityDetails, item => item.id);
  switch (user_type) {
    case "staff":
      if (id && !_.isEmpty(validIds)) {
        return _.includes(validIds, id);
      }
      break;

    case "student":
      if (id) {
        return true;
      }
      break;
  }
  return true;
};

/** __FamilyPortal__
 * 1. When last remaining child is removed from family portal, we will need "parentToken" to add new child
 * 2. In FamilyPortal "parentToken" refers jwt of parent and "token" refers to jwt of child
 * Note: For student and teacher if condition will not be executed
 *
 * when user hit public route that time we send public jwt.
 */
const getToken = (userInfo, state) => {
  const isParent = _.isEqual(_.get(userInfo, "user_type"), "parent");
  if (isPublicPlatformRoute()) {
    const publicToken = _.get(state, "login.publicToken");
    return `Bearer ${publicToken}`;
  }
  if (isParent && _.isEmpty(_.get(userInfo, "token", ""))) {
    return `Bearer ${userInfo.parentToken}`;
  }
  return `Bearer ${userInfo.token}`;
};

const authLink = setContext((request, previousContext) => {
  const trace = Sentry.getCurrentHub().traceHeaders();
  const extensions = getExtensions({ request });
  if (request?.extensions) {
    request.extensions.route = extensions.route;
    request.extensions.href = extensions.href;
  }
  return new Promise((success, fail) => {
    const state = store.getState();

    const loginPortalType = _.get(state, "login.portalType", null);
    const useDefaultRegion = _.isEqual(loginPortalType, "COMMON");

    const sampleOrgPortalType = _.get(
      state,
      "platform.sampleOrgPortalType",
      ""
    );

    const connectionId = _.get(
      connectionManager.getConnection(),
      "connection.id",
      ""
    );

    const portalType =
      _.get(request, "variables.portalType", "") ||
      _.get(previousContext, "portalType", "") ||
      sampleOrgPortalType ||
      loginPortalType;

    const userInfo = getUserInfo({ portalType });

    if (checkIsValidUser({ userInfo })) {
      success({
        headers: {
          Authorization: userInfo ? getToken(userInfo, state) : null,
          "X-Tod-Connection-Id": connectionId,
          "X-Tod-Source": "WEB",
          "X-Tod-Lang": i18n?.language || "en",
          ...trace,
        },
        fetchOptions: { useDefaultRegion },
      });
    } else {
      window.location.href = "/";
      fail();
    }
  });
});

export default authLink;
